// A new scenario (R-C12): a draft on the first section of records, opened once the server took it; a refusal is said aloud.

import { uuidv7, type AutomationSpec, type MetaIndex } from '@confdeck/core-shared';
import type { SyncClient } from '../sync/client.ts';
import { navigate } from '../shell/router.ts';

/** `onError` says why the server refused (MiniMax review wave 2: a refusal used to go unanswered). */
export async function createAutomation(client: SyncClient, meta: MetaIndex, onError: (text: string) => void) {
  const t = meta.types()[0];
  if (!t) { onError('Нет разделов записей, на которые может срабатывать сценарий'); return; }
  const nid = uuidv7();
  const spec: AutomationSpec = { name: 'Новый сценарий', description: '', trigger: { type: 'record.created', typeId: t.id }, conditions: null, steps: [] };
  const r = await client.run('automation.save', { id: nid, ...spec });
  if (!r.ok) { onError(r.error.message); return; }
  navigate(`/a/${nid}`);
}
